export const z3k_device_history_reducer = (state = {
    current_device_id: -1,
    config_history: [],
    is_config_set_load: false,
}, action) => {
    switch (action.type) {
        case 'LOAD_DEVICE_CONFIG':
            return {
                ...state,
                current_device_id: action.device_id,
                config_history: action.config_history,
            };
        case 'SET_LOADING_STATE':
            return {
                ...state,
                is_config_set_load: action.loading_state,
            };
        default:
            return state;
    }
};
